export const CallForPriceButtonLocalize = {
  callForPrice: $localize`:@@ideal-item-price-view.call-for-price:Call for Price and Availability`,
  callForPriceShort: $localize`:@@ideal-item-price-view.call-for-price.short:Call for Price`,
} as const;
